// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AgeVerificationOnlyController from "./age_verification_only_controller"
application.register("age-verification-only", AgeVerificationOnlyController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConfirmationModalController from "./confirmation_modal_controller"
application.register("confirmation-modal", ConfirmationModalController)

import EventReservationController from "./event_reservation_controller"
application.register("event-reservation", EventReservationController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import OrganizationEventsController from "./organization_events_controller"
application.register("organization-events", OrganizationEventsController)

import ReservationChangeWarningController from "./reservation_change_warning_controller"
application.register("reservation-change-warning", ReservationChangeWarningController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)
